import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import EnsureLoggedInContainer from './EnsureLoggedInContainer';

const EnsureLoggedInRoute = (props) => {
  const { component: TargetComponent, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(childProps) => (
        <EnsureLoggedInContainer>
          <TargetComponent {...childProps} />
        </EnsureLoggedInContainer>
      )}
    />
  );
};

EnsureLoggedInRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.func }),
  ]).isRequired,
};

export default EnsureLoggedInRoute;
